import { PageTemplate } from '@/shared/ui/templates';
import styles from './index.module.sass';
import classNames from 'classnames';
import { RecipeResultStep } from '../../components/recipe-result-step';
import { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import {
  $mixingParamsError,
  $searchBatches,
  $searchBatchesStatus,
  fetchAvailableBunkers,
  fetchSearchBatches,
  getMixingParams,
  setSearchBatches,
  setSearchBatchesStatus,
} from '@/widgets/recipe/model';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ManualMixingResultItem } from '../../components/manual-mixing-result-item';
import { notification } from 'antd';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
import { clearLastSearchResult } from '@/modules/common/helpers/cache-search-result.helper';
import { Modal } from 'antd';
import { PlaceholderEmpty } from '@/modules/common/components/placeholder-empty';

export const ManualMixingPage = () => {
  const [params] = useSearchParams();
  //const resultData = useStore($mixingParamsData);
  const data = useStore($searchBatches);
  const requestStatus = useStore($searchBatchesStatus);
  const navigate = useNavigate();

  let queryWheatParams: any = {
    warehouse_id: params.get('warehouse_id')?.split(','),
    cp: Number(params.get('cp')) || 0,
    nature: Number(params.get('nature')) || 0,
    humidity: Number(params.get('humidity')) || 0,
    protein: Number(params.get('protein')) || 0,
    gluten: Number(params.get('gluten')) || 0,
    idk: Number(params.get('idk')) || 0,
    deviation: Number(params.get('deviation')) || 0,
    temperature: Number(params.get('temperature')) || 0,
    wheat_class: Number(params.get('class')) || 0,
    wheat_type: Number(params.get('type')) || 0,
    range: params.get('range') || false,
  };

  if (queryWheatParams.range) {
    queryWheatParams = {
      ...queryWheatParams,
      cp_to: Number(params.get('cp_to')) || 0,
      nature_to: Number(params.get('nature_to')) || 0,
      humidity_to: Number(params.get('humidity_to')) || 0,
      protein_to: Number(params.get('protein_to')) || 0,
      gluten_to: Number(params.get('gluten_to')) || 0,
      idk_to: Number(params.get('idk_to')) || 0,
    };
  }

  useEffect(() => {
    fetchAvailableBunkers();

    return () => {
      getMixingParams(null as any);
      setSearchBatches(null);
      setSearchBatchesStatus({ error: false, loading: false });
    };
  }, []);

  useEffect(() => {
    // @ts-ignore
    if (data?.error || data?.errors) {
      let res: any = data;
      if (res?.errors) {
        let result: string[] = [];
        for (const key in res?.errors) {
          if (res.errors?.hasOwnProperty(key)) {
            result = result.concat(res.errors[key]);
          }
        }
        result.map((item) => notification.warning({ message: item }));
        return;
      }
      if (res?.error) {
        notification.warning({ message: res?.error });
        return;
      }
      requestStatus.error &&
        notification.warning({
          message: res || 'Непредвиденная ошибка при поиске товарных партий',
        });

      //return navigate('/search');
    }
  }, [data]);

  useEffect(() => {
    let reqObj: any = {
      warehouse_id: params.get('warehouse_id')?.split(','),
      cp: Number(params.get('cp')) || 0,
      nature: Number(params.get('nature')) || 0,
      humidity: Number(params.get('humidity')) || 0,
      protein: Number(params.get('protein')) || 0,
      gluten: Number(params.get('gluten')) || 0,
      idk: Number(params.get('idk')) || 0,
      deviation: Number(params.get('deviation')) || 0,
      temperature: Number(params.get('temperature')) || 0,
      wheat_class: Number(params.get('class')) || 0,
      wheat_type: Number(params.get('type')) || 0,
      range: params.get('range') || false,
    };

    if (reqObj.range === 'true') {
      reqObj = {
        ...reqObj,
        cp_to: Number(params.get('cp_to')) || 0,
        nature_to: Number(params.get('nature_to')) || 0,
        humidity_to: Number(params.get('humidity_to')) || 0,
        protein_to: Number(params.get('protein_to')) || 0,
        gluten_to: Number(params.get('gluten_to')) || 0,
        idk_to: Number(params.get('idk_to')) || 0,
      };
    }
    //fetchMixingParamsData(reqObj as any);
    fetchSearchBatches(
      reqObj.range === 'true'
        ? {
            warehouse_id: reqObj.warehouse_id
              ? (reqObj.warehouse_id.map((item: any) => +item) as any)
              : [],
            protein_from: reqObj.protein,
            protein_upto: reqObj.protein_to,
            gluten_from: reqObj.gluten,
            gluten_upto: reqObj.gluten_to,
            idk_from: reqObj.idk,
            idk_upto: reqObj.idk_to,
            moisture_from: reqObj.humidity,
            moisture_upto: reqObj.humidity_to,
            moisture_enable: false,
            density_from: reqObj.nature,
            density_upto: reqObj.nature_to,
            wheat_type: reqObj.wheat_type,
            hfn_from: reqObj.cp,
            hfn_upto: reqObj.cp_to,
            //deviation: reqObj.deviation,
          }
        : {
            warehouse_id: reqObj.warehouse_id
              ? (reqObj.warehouse_id.map((item: any) => +item) as any)
              : [],
            protein_from: reqObj.protein,
            gluten_from: reqObj.gluten,
            idk_upto: reqObj.idk,
            moisture_upto: reqObj.humidity,
            density_from: reqObj.nature,
            wheat_type: reqObj.wheat_type,
            hfn_from: reqObj.cp,
            deviation: reqObj.deviation,
          },
    );
  }, [params]);

  // useEffect(() => {
  //   if (resultData?.errors) {
  //     const errorArray = Object.entries(resultData?.errors).flatMap(
  //       ([key, value]) => value,
  //     );
  //     errorArray.map((item) =>
  //       notification.warning({
  //         message: String(item),
  //       }),
  //     );
  //   }
  // }, [resultData]);

  //const modalSearchData = localStorage.getItem('searchModalState');
  return (
    <>
      <PageTemplate
        customBackAction={() => {
          Modal.confirm({
            title: 'Подтвердите действие',
            content:
              'При переходе на основную страницу, результаты нынешнего поиска будут сброшены. Сброcить результаты?',
            okText: 'да',
            okButtonProps: { danger: true },
            onOk: () => {
              clearLastSearchResult();
              navigate('/search');
            },
            cancelText: 'нет',
          });
        }}
        customAction={{
          label: 'сбросить результаты поиска',
          action: () => {
            clearLastSearchResult();
            navigate('/search');
          },
          markered: true,
        }}
        className={classNames(styles.background)}
        header="поиск зерна по заданным параметрам"
        customBack={'/search'}
      >
        {data && !requestStatus.loading && !requestStatus.error ? (
          <>
            <div className={styles.indicatorsWrap}>
              <RecipeResultStep
                agricultureId={1}
                type={queryWheatParams?.wheat_type}
                classN={queryWheatParams?.wheat_class}
                variant={'widget'}
                specs={[
                  {
                    label: 'клейковина',
                    value:
                      queryWheatParams.range === 'true'
                        ? `${queryWheatParams?.gluten} - ${queryWheatParams?.gluten_to}`
                        : queryWheatParams?.gluten || 0,
                    postfix: '%',
                  },
                  {
                    label: 'влажность',
                    value:
                      queryWheatParams.range === 'true'
                        ? `${queryWheatParams?.humidity} - ${queryWheatParams?.humidity_to}`
                        : queryWheatParams?.humidity ?? 0,
                    postfix: '%',
                  },
                  {
                    label: 'ИДК',
                    value:
                      queryWheatParams.range === 'true'
                        ? `${queryWheatParams?.idk} - ${queryWheatParams?.idk_to}`
                        : queryWheatParams?.idk ?? 0,
                    postfix: '',
                  },
                  {
                    label: 'число падения',
                    value:
                      queryWheatParams.range === 'true'
                        ? `${queryWheatParams?.cp} - ${queryWheatParams?.cp_to}`
                        : queryWheatParams?.cp ?? 0,
                    postfix: 'сек',
                  },
                  {
                    label: 'протеин',
                    value:
                      queryWheatParams.range === 'true'
                        ? `${queryWheatParams?.protein} - ${queryWheatParams?.protein_to}`
                        : queryWheatParams?.protein ?? 0,
                    postfix: '%',
                  },
                  {
                    label: 'натура',
                    value:
                      queryWheatParams.range === 'true'
                        ? `${queryWheatParams?.nature} - ${queryWheatParams?.nature_to}`
                        : queryWheatParams?.nature ?? 0,
                    postfix: 'г/л',
                  },
                ]}
              />
            </div>
            <div className={styles.cardsWrap}>
              {data?.length < 1 || !Array.isArray(data) ? (
                <PlaceholderEmpty
                  title="Не найдено зерно под указанные параметры"
                  label="На Ваших складах пока что отсутствует зерно по параметрам выбранного предложения покупателя"
                />
              ) : (
                data?.map((item) => (
                  <ManualMixingResultItem
                    title={item.name}
                    weight={item.total_weight}
                    warehouseType={item.warehouse_type}
                    mixData={{
                      action: () => {
                        const bags = item.mixes.map((item) => item.id);
                        //navigate(`/storage?wh-id=${item.id}&bags=${bags}`);
                        navigate({
                          pathname: `/mixing/recipes-new`,
                          search: `?warehouse_id=${
                            item.id
                          }&active_tab=1&markered_bags=${bags.toString()}`,
                        });
                      },
                      weigth: item.mixes.reduce((acc, curr) => acc + curr.weight, 0),
                      count: item.mixes.length,
                    }}
                    noMixData={{
                      action: () => {
                        const bags = item.bags.map((item) => item.id);
                        //navigate(`/storage?wh-id=${item.id}&bags=${bags}`);
                        navigate({
                          pathname: `/mixing/recipes-new`,
                          search: `?warehouse_id=${
                            item.id
                          }&active_tab=0&markered_bags=${bags.toString()}`,
                        });
                      },
                      weigth: item.bags.reduce((acc, curr) => acc + curr.weight, 0),
                      count: item.bags.length,
                    }}
                  />
                ))
              )}
            </div>
            {/* {displayDialog && (
              <SelectBunkerModal
                recipeId={selectedWarehouse}
                options={bunkerData?.map((item: any) => ({
                  value: item.id,
                  label: item.model_name,
                  tonnage: item.lifting_capacity,
                }))}
                onClose={() => setDisplayDialog(false)}
              />
            )} */}
          </>
        ) : (
          <UniversalLoader error={requestStatus.error} />
        )}
      </PageTemplate>
    </>
  );
};
